import Login from './login';
import ForgotPassword from './forgot';
import ResetPassword from './reset';

export default {
  Login,
  ForgotPassword,
  ResetPassword
};
